import { UpdateUserDto, UsersV2Api } from '../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UpdateOwnProfileVariables = {
  updateUserDto: UpdateUserDto;
  userId: string;
};

type UseUpdateOwnProfileV2 = (
  usersV2Api: UsersV2Api,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, UpdateOwnProfileVariables>,
    'mutationFn'
  >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, UpdateOwnProfileVariables>;

export const useUpdateOwnProfileV2: UseUpdateOwnProfileV2 = (usersV2Api, options) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    ({ updateUserDto, userId }) => usersV2Api.updateUser(tenantId, userId, updateUserDto),
    options,
  );
};
